/**
 * Counting the answers in the key box.
 *
 * The number under the box is a check a teacher makes against the paper — "38
 * answers under a 40-question paper" is worth seeing before the import rather
 * than after it. So it has to count the way the importer counts, and it did
 * not: a key joining two questions as "14 & 15" was read as one answer here
 * and as two on the way in, so the screen said 34 for a key of 40.
 */

/** "IN EITHER ORDER" — an instruction to the marker, not part of an answer. */
const ORDER_NOTE = /\b(?:in\s+(?:either|any)\s+order)\b[\s.,;:-]*/gi;

const RANGE = /^\s*(\d{1,2})\s*[-–—]\s*(\d{1,2})\s*[.)\]:]?\s+\S/;
const JOINED = /^\s*(\d{1,2})\s*(?:&|\/|\band\b)\s*(\d{1,2})\b/i;
const SINGLE = /^\s*(\d{1,2})\s*[.)\]:–-]?\s+\S/;

/** How many questions the key in this box answers. */
export function countKeyedAnswers(key: string): number {
  let total = 0;
  for (const line of key.split('\n')) {
    const cleaned = line.replace(ORDER_NOTE, ' ');

    const range = RANGE.exec(cleaned);
    if (range) {
      total += Math.max(1, Number(range[2]) - Number(range[1]) + 1);
      continue;
    }
    const joined = JOINED.exec(cleaned);
    if (joined) {
      total += Math.max(1, Number(joined[2]) - Number(joined[1]) + 1);
      continue;
    }
    if (SINGLE.test(cleaned)) total += 1;
  }
  return total;
}
